import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { AuthStoreService } from 'src/app/services/auth.store';

export const InviteGuard: CanActivateFn = (next) => {
  const invkey = next.queryParams['invkey'];

  if (!invkey) {
    return inject(Router).navigate(['/home']);
  }

  const generalService = inject(GeneralService);
  const sd = inject(AuthStoreService).subdomain(); // URL-derived, always available synchronously
  const returnUrl = window.location.origin + '/';
  const authUrl = generalService.getAuthUrl(`/signup?returnUrl=${encodeURIComponent(returnUrl)}&sd=${sd}&invkey=${invkey}`);
  window.location.href = authUrl;
  return false;
};
